import { render, staticRenderFns } from "./initOrg.vue?vue&type=template&id=ce8d3f8e&scoped=true&"
import script from "./initOrg.vue?vue&type=script&lang=js&"
export * from "./initOrg.vue?vue&type=script&lang=js&"
import style0 from "./initOrg.vue?vue&type=style&index=0&id=ce8d3f8e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce8d3f8e",
  null
  
)

export default component.exports